import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ReplyToClientActionsStore = {
  actionsByMessageId: Record<string, Array<string>>;
  lastMessageId: Maybe<string>;
  actions: {
    updateActions: (messageId: string, actions: Array<string>) => void;
  };
};

const LOCAL_STORAGE_KEY = 'wg-reply-to-client-actions';

const INITIAL_VALUES: Omit<ReplyToClientActionsStore, 'actions'> =
  Object.freeze({
    actionsByMessageId: {},
    lastMessageId: undefined,
  });

const useReplyToClientActionsStore = create<ReplyToClientActionsStore>()(
  persist(
    (set) => ({
      ...INITIAL_VALUES,

      actions: {
        updateActions: (messageId: string, actions: Array<string>) =>
          set((state) => ({
            ...state,
            actionsByMessageId: {
              ...state.actionsByMessageId,
              [messageId]: actions,
            },
            lastMessageId: messageId,
          })),
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
      version: 0,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);

export default useReplyToClientActionsStore;
